import { httpClient } from "src/shared/services/httpClient";
import { AxiosResponse } from "axios";
import { LoginResponseDto } from "src/authentication/types";

export interface ILoginUser {
  username: string;
  password: string;
}

export const loginCall = ({
  userData,
  type,
}: {
  userData: ILoginUser;
  type: "user" | "nonGemi" | "chamber" | "region";
}): Promise<AxiosResponse<LoginResponseDto>> => {
  const endpoint =
    type == "user"
      ? "/welcome/login"
      : type == "nonGemi"
        ? "/welcome/loginNonGemiUser"
        : type == "chamber"
          ? "/welcomeGovChamber/login"
          : type == "region"
            ? "/welcomeGovRegion/login"
            : "";

  return httpClient.post(
    endpoint,
    {
      username: userData.username,
      password: userData.password,
    },
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    },
  );
};

export const loginChamberCall = (userData: ILoginUser) =>
  httpClient.post(
    "/welcomeGovChamber/login",
    {
      username: userData.username,
      password: userData.password,
    },
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    },
  );

export const loginRegionCall = (userData: ILoginUser) =>
  httpClient.post(
    "/welcomeGovRegion/login",
    {
      username: userData.username,
      password: userData.password,
    },
    {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    },
  );

export const userInfo = () => httpClient.get("/business/changeInfoForm");
export const checkUserSession = () =>
  httpClient.get("/authentication/checkSession");

export const logoutCall = () => httpClient.get("/authentication/logout");

export const resendValidationEmail = (mailValidationToken: string) => {
  const formData = new FormData();
  formData.append("mailValidationToken", mailValidationToken);
  return httpClient.post("/welcomeNonGemi/resendValidationEmail", formData);
};
